import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

  isShowCookie: boolean = false;
  currentLanguage = this.commonService.currentLanguage;
  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }

  showCookie() {
    this.isShowCookie = true
  }

}
